define('views/modules/profile/edit/preferences-edit-form-business',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    'services/user',
    // collections
    'collections/member/groups',
    'collections/calendar/personal-data/personal-data-types',
    // views
    'views/parts/form/textbox',
    'views/parts/form/select',
    'views/parts/form/datepicker',
    'views/parts/form/choices',
    'views/parts/info-section',
    // templates
    'text!templates/modules/profile/edit/preferences-edit-form-business.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    User,
    // collections
    CGroups,
    CPersonalDataTypes,
    // views
    VTextBox,
    VSelect,
    VDatePicker,
    VChoices,
    VInfoSection,
    // templates
    TPreferencesEditFormBusiness
) {

    var VPreferencesEditFormBusiness = Backbone.View.extend({
        template: TPreferencesEditFormBusiness,

        regions: {
            root: '.personal-info-edit',
            // nameFormat: '.name-format-input',
            mainGroup: '.main-group-input',
            firstStat: '.first-stat',
            secondStat: '.second-stat',
            thirdStat: '.third-stat',
            daysBeforeCalendarItemsAreHiddenCheckbox: '.hide-sessions-checkbox',
            daysBeforeCalendarItemsAreHiddenInput: '.hide-sessions-input',
            favoriteExercisesType: '.favorite-exercises-type',
            disableAnimatedSessions: '.disable-animated-sessions-checkbox'
        },

        initialize: function(opt) {
            this.options = opt || {};

            this.personalDataTypes = new CPersonalDataTypes();

            this.daysBeforeCalendarItemsAreHiddenModel = new Backbone.Model({ show: false });
            this.originalDaysBeforeCalendarItemsAreHiddenValue = this.options.group.get('daysBeforeCalendarItemsAreHidden');

            this.personalDataModel = new Backbone.Model({ firstStat: U.nullId, secondStat: U.nullId, thirdStat: U.nullId });

            var model = this.model,
                collection = this.collection = new CGroups(null, { removeExpired: true }),
                nameFormats = new Backbone.Collection([{
                        label: Mustache.render(i18n.t("Normal ({{name}})", {
                            name: model.get('name')
                        })),
                        value: '[firstname] [lastname]'
                    },
                    {
                        label: Mustache.render(i18n.t("Inverted ({{lastname}} {{firstname}})", {
                            firstname: model.get('firstname'),
                            lastname: model.get('lastname'),
                        })),
                        value: '[lastname] [firstname]'
                    },
                ]);

            this.view = {
                info: new VInfoSection({
                    title: "Preferences",
                    content: this.template,
                }),
                mainGroup: new VSelect({
                    option: { label: 'name', value: 'id' },
                    model: model,
                    attribute: 'mainGroup',
                    collection: collection,
                    context: this,
                }),
                // nameFormat: new VSelect({
                //     option: { label: 'label', value: 'value', skipTranslation: true },
                //     attribute: 'nameFormat',
                //     model: model,
                //     collection: nameFormats,
                //     context: this,
                // }),
                firstStat: new VSelect({
                    option: { label: 'name', value: '_id' },
                    model: this.personalDataModel,
                    attribute: 'firstStat',
                    collection: this.personalDataTypes,
                    context: this,
                }),
                secondStat: new VSelect({
                    option: { label: 'name', value: '_id' },
                    model: this.personalDataModel,
                    attribute: 'secondStat',
                    collection: this.personalDataTypes,
                    context: this,
                }),
                thirdStat: new VSelect({
                    option: { label: 'name', value: '_id' },
                    model: this.personalDataModel,
                    attribute: 'thirdStat',
                    collection: this.personalDataTypes,
                    context: this,
                }),
                daysBeforeCalendarItemsAreHiddenCheckbox: new VChoices({
                    model: this.daysBeforeCalendarItemsAreHiddenModel,
                    label: 'hide-items-that-are-too-far-in-the-future',
                    attribute: 'show',
                    labelposition: "top",
                    context: this,
                }),
                disableAnimatedSessions: new VChoices({
                    model: this.model,
                    label: 'settings:keep-clients-from-creating-or-editing-sessions',
                    attribute: '_disable_animated_sessions',
                    labelposition: "top",
                    context: this,
                }),
                daysBeforeCalendarItemsAreHiddenInput: new VTextBox({
                    model: this.options.group,
                    type: 'number',
                    attribute: 'daysBeforeCalendarItemsAreHidden',
                    addon: true,
                    addonAfter: i18n.t('days'),
                    label: 'hide-sessions-label',
                    help: 'hide-sessions-helptext',
                    labelposition: 'top',
                    context: this,
                    min: 0
                }),
                favoriteExercisesType: new VSelect({
                    option: { label: 'name', value: 'id' },
                    model: model,
                    attribute: 'favorite_exercises_type',
                    collection: new Backbone.Collection([
                        { id: '3D', name: 'exercises-3d' },
                        { id: 'live', name: 'exercises-live' },
                        { id: 'both', name: 'both' },
                    ]),
                    context: this,
                })
            };

            this.listenTo(collection, 'sync', this.onCollectionSync);
            this.listenTo(this.personalDataModel, 'change', this.onPersonalDataModelChange);
            this.listenTo(this.personalDataTypes, 'sync', this.onPersonalDataTypesSync);
            this.listenTo(this.daysBeforeCalendarItemsAreHiddenModel, 'change', this.onDaysBeforeCalendarItemsAreHiddenModelChange);
        },
        render: function() {
            // Check if we need to display the "daysBeforeCalendarItemsAreHidden" section or not
            this.daysBeforeCalendarItemsAreHiddenModel.set({ show: this.options.group.get('daysBeforeCalendarItemsAreHidden') ? true : false });
            this.originalDaysBeforeCalendarItemsAreHiddenValue = this.options.group.get('daysBeforeCalendarItemsAreHidden');

            // append the form
            this.assign(this.view.info, this.$el)
                .generateZones();

            var view = this.view,
                zone = this.zone;

            this.assign(view.mainGroup, zone.$mainGroup)
                // .assign(view.nameFormat, zone.$nameFormat)
                .assign(view.firstStat, zone.$firstStat)
                .assign(view.secondStat, zone.$secondStat)
                .assign(view.thirdStat, zone.$thirdStat)
                .assign(view.daysBeforeCalendarItemsAreHiddenCheckbox, zone.$daysBeforeCalendarItemsAreHiddenCheckbox)
                .assign(view.daysBeforeCalendarItemsAreHiddenInput, zone.$daysBeforeCalendarItemsAreHiddenInput)
                .assign(view.favoriteExercisesType, zone.$favoriteExercisesType)
                .assign(view.disableAnimatedSessions, zone.$disableAnimatedSessions);

            if (this.daysBeforeCalendarItemsAreHiddenModel.get('show')) {
                zone.$daysBeforeCalendarItemsAreHiddenInput.show();
            }

            if (! User.getMainGroup().isOwner) {
                this.$el.find('.hide-sessions-section').html('');
                this.$el.find('.feature-deactivation').html('');
            }

            this.collection.fetch();
            this.personalDataTypes.fetch({ remove: false });

            this.setCustomDataValues();

            return this;
        },

        getSelectedCustomDataTypesIds: function() {
            return [this.view.firstStat.getValue(), this.view.secondStat.getValue(), this.view.thirdStat.getValue()];
        },

        setCustomDataValues: function() {
            this.personalDataModel.set({
                firstStat: this.model.get('customDataDefIds')[0] || U.nullId,
                secondStat: this.model.get('customDataDefIds')[1] || U.nullId,
                thirdStat: this.model.get('customDataDefIds')[2] || U.nullId,
            }, { silent: true });
        },

        onCollectionSync: function(collection) {
            this.zone.$mainGroup.toggle(collection.length > 1);
            this.view.mainGroup.setValue(this.model.getMainGroupId(), { silent: true });
        },

        onPersonalDataModelChange: function() {
           this.model.set('customDataDefIds',
               _.filter(
                   this.getSelectedCustomDataTypesIds(),
                   function(customDataId) { return customDataId !== U.nullId && customDataId.length === 24;  },
                   this
               )
           );
        },

        onPersonalDataTypesSync: function() {
            this.personalDataTypes.unshift({ name: 'none', _id: U.nullId });
        },

        onDaysBeforeCalendarItemsAreHiddenModelChange: function(model) {
            this.options.group.set({ daysBeforeCalendarItemsAreHidden: this.originalDaysBeforeCalendarItemsAreHiddenValue });

            if (! model.get('show')) {
                this.options.group.set({ daysBeforeCalendarItemsAreHidden: false });
            }

            this.$el.find(this.regions.daysBeforeCalendarItemsAreHiddenInput).slideToggle(model.get('show'));
        }
    });

    return VPreferencesEditFormBusiness;
});

